// 회원권 카드 하단 액션 버튼 배치.
// 2열로 채우되 개수가 홀수면 마지막 하나만 한 줄을 전부 차지한다(CardButton 이 flex:1 이라 자동).
export const toActionRows = actions => {
  const rows = [];
  for (let i = 0; i < actions.length; i += 2) {
    rows.push(actions.slice(i, i + 2));
  }
  return rows;
};
